export default __webpack_public_path__ + "static/media/modal-approved-icon.bf1f24c2.svg";